import { useStorage } from '@vueuse/core';

export const layout = useStorage(import.meta.env.VITE_LOCALSTORAGE_KEY_NAME + '_layout', {
  isListFullHeight: false,
  listPanelSize: 30,
  combinedPanelSize: 70,
  viewPanelSize: 50,
  tablePanelSize: 50
});
